type DateOffset = {
  years?: number;
  months?: number;
  weeks?: number;
  days?: number;
  hours?: number;
  minutes?: number;
  seconds?: number;
};

export function createDefaultDate(
  offset: DateOffset = {},
  from: Date = new Date(),
): Date {
  const date = new Date(from);

  if (offset.years) date.setFullYear(date.getFullYear() + offset.years);
  if (offset.months) date.setMonth(date.getMonth() + offset.months);
  if (offset.weeks) date.setDate(date.getDate() + offset.weeks * 7);
  if (offset.days) date.setDate(date.getDate() + offset.days);
  if (offset.hours) date.setHours(date.getHours() + offset.hours);
  if (offset.minutes) date.setMinutes(date.getMinutes() + offset.minutes);
  if (offset.seconds) date.setSeconds(date.getSeconds() + offset.seconds);

  return date;
}
